import { render } from "./PracticeSelectorMenu.vue?vue&type=template&id=0a61aa86&scoped=true"
import script from "./PracticeSelectorMenu.vue?vue&type=script&lang=js"
export * from "./PracticeSelectorMenu.vue?vue&type=script&lang=js"

import "./PracticeSelectorMenu.vue?vue&type=style&index=0&id=0a61aa86&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a61aa86"]])

export default __exports__